
interface NotificationProps {
  date: string;
  title: string;
  /** The reviewer's own comment / rejection reason. Absent on many decisions. */
  message?: string;
  time: string
  status: 'approved' | 'pending' | 'rejected';
  read?: boolean;
  onClick?: () => void;
}

const NotificationComp = ({ date, title, message, status, time, read, onClick }:NotificationProps) => {
  let statusColor;
  switch (status) {
    case 'approved':
      statusColor = 'bg-green-400';
      break;
    case 'pending':
      statusColor = 'bg-yellow-400';
      break;
    case 'rejected':
      statusColor = 'bg-red-400';
      break;
  }

  return (
    <div className="flex  relative text-gray-500 border-s border-gray-200 ">
        <div
            className={`mb-10 ms-6 ${onClick ? 'cursor-pointer' : ''}`}
            onClick={onClick}
            title={read === false ? 'Mark as read' : undefined}
        >
            <span className={`absolute flex items-center justify-center w-4 h-4 ${statusColor} rounded-full -start-2 ring-4 ring-white `}></span>
            <div className="flex-1 text-sm">
                <div className="font-medium">{date}</div>
                <div className={read === false ? 'font-semibold text-gray-900' : 'font-medium'}>{title}</div>
                {message && <div className="text-xs mt-1 text-gray-500">{message}</div>}
                <div className="text-xs mt-1">{time}</div>
            </div>
        </div>
    </div>
  );
};
export default NotificationComp
